
export class GigyaUtils {

    static isGigyaSdkLoaded (promiseToReject) {

        let isLoaded = (typeof gigya !== 'undefined');

        if (promiseToReject && !isLoaded) {

            promiseToReject.reject({
                reason: 'TECH',
                message: __('GIGYA_SDK_NOT_LOADED')
            });
        }

        return isLoaded;
    }

    static getGigyaErrorMessage (response) {

        if (response.errorCode === 0) {

            return;
        }

        switch (response.errorCode) {

            // User disabled in GIGYA
            case 403041 : {

                return {
                    reason: 'GIGYA',
                    message: __('GIGYA_ACCOUNT_DISABLED')
                };
            }

            // Incorrect login/pass pair
            case 403042 : {

                return {
                    reason: 'GIGYA',
                    message: __('GIGYA_INCORRECT_PASSWORD')
                };
            }

            // Reset password link expired
            case 400006 : {

                return {
                    reason: 'GIGYA',
                    message: __('RESET_PASSWORD_LINK_EXPIRED')
                };
            }

            //Account Temporarily Locked Out : occured because, attempts exceeded
            case 403120 : {

                return {
                    reason: 'GIGYA',
                    message: __('INVALID_NUMBER_OF_ATTEMPTS')
                };
            }

            // Invalid OAuth2 token
            case 403025: {

                return {
                    reason: 'GIGYA',
                    message: __('GIGYA_INVALID_TOKEN')
                };
            }

            // All other problems
            default : {

                return {
                    reason: 'TECH',
                    message: response.errorMessage
                };
            }
        }
    }
}


// WEBPACK FOOTER //
// ./shared/utils/GigyaUtils.js